import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkFlowReducers } from '../app.reducers';

const getIntegrationSelectorState = createFeatureSelector<WorkFlowReducers.WorkFlowState>(WorkFlowReducers.TAG);

export const getWorkFlowConfigurations = createSelector(getIntegrationSelectorState, (state) => state?.workFlowConfig);
export const getWorkFlowInstance = createSelector(getIntegrationSelectorState, (state) => state?.workFlowInstance);
